import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

class SignupIndexController extends Controller {
  @service router;

  @computed('model.user.firstName')
  get firstName() {
    return this.model.user.firstName;
  }

  @action
  continueSetup() {
    switch (this.model.user.signupStep) {
      case 'validate_email':
        return this.router.transitionTo(EMBER_ROUTE_NAMES.SIGNUP__STEP__VERIFY_EMAIL);

      case 'extended_profile':
        return this.router.transitionTo(EMBER_ROUTE_NAMES.SIGNUP__STEP__BACKGROUND);

      case 'work_samples':
        return this.router.transitionTo(EMBER_ROUTE_NAMES.SIGNUP__STEP__WORK);

      case 'done':
        return this.router.transitionTo(EMBER_ROUTE_NAMES.SIGNUP__STEP__DONE);

      default:
        return this.router.transitionTo(EMBER_ROUTE_NAMES.SIGNUP__STEP__PROFILE);
    }
  }
}

export default SignupIndexController;
